


























import { Component, Vue, Prop } from 'vue-property-decorator';

type RatingState = 'stars' | 'loading';

@Component
export default class OrderRatingWidget extends Vue {
    @Prop({ default: '/om-oss/rating-feedback' })
    private feedbackUrl!: string;

    @Prop({ default: '/om-oss/rating-thanks' })
    private thankyouUrl!: string;

    private state: RatingState = 'stars';
    private hoveredRating: number = 0;
    private selectedRating: number = 0;
    private orderId: string = '';
    private externalOrderId: string = '';

    mounted() {
        const feedbackEl = document.getElementById('tempOrderFeedback');
        if (feedbackEl) {
            this.orderId = feedbackEl.dataset.orderId || '';
            this.externalOrderId = feedbackEl.dataset.externalOrderId || '';
        }
    }

    private onStarClick(rating: number): void {
        this.selectedRating = rating;
        this.state = 'loading';

        const targetUrl = rating >= 4 ? this.thankyouUrl : this.feedbackUrl;

        setTimeout(() => {
            const params = new URLSearchParams({ betyg: String(rating) });
            if (this.externalOrderId) params.set('ordernumber', this.externalOrderId);
            window.location.href = `${targetUrl}?${params.toString()}`;
        }, 350);
    }
}
